import options from './header.component';

export default {
    selector: 'dtLayoutHeader',
    options
};
